import React from "react";
import Table from "../list/Table";
import { Link } from "react-router-dom";
import { IoMdPersonAdd } from "react-icons/io";
import { useTranslation } from "react-i18next";
import objectPath from "object-path";
import { API_ROOT } from "../defines";
import { ArrowCircleRight2 } from "iconsax-react";
import moment from "moment";
import { useApp } from "../providers/app";
const statusList = [
  { label: "新品", value: "new" },
  { label: "被拒绝", value: "declined" },
  { label: "已安排", value: "scheduled" },
  { label: "完毕。", value: "finished" },
];
const List = () => {
  const { user } = useApp();
  const { t } = useTranslation();
  const defaultFind =
    user?.role == "admin"
      ? {}
      : user?.role == "factory"
      ? {
          factory: user?.id,
        }
      : {
          manager: { $in: [user?.id, null] },
        };
  console.log("🚀 ~ List ~ defaultFind:", defaultFind);
  return (
    <div className="flex flex-col ">
      <div className="flex items-center justify-between w-full h-20 py-3 px-8">
        <div className="text-xl font-semibold leading-5 text-black ">
          {t("order.name")}
        </div>
      </div>
      <div className="px-4">
        <Table
          url={`/order/table`}
          sort={{ _id: -1 }}
          defaultFind={defaultFind}
          columns={[
            {
              width: 20,
              render: ({ _id, email }) => {
                return (
                  <Link
                    to={`view/${_id}`}
                    className="flex w-16 max-w-16 self-center"
                  >
                    <ArrowCircleRight2 size="32" color="#1A2E55" />
                  </Link>
                );
              },
            },
            {
              label: t("order.status"),
              key: `status`,
              sort: true,
              filter: {
                type: "select",
                items: statusList,
              },
              render: ({ _id, status }) => {
                const temp = statusList.filter((r) => r.value == status);
                return (
                  <div class="text-primary">
                    {objectPath.get(temp, "0.label")}
                  </div>
                );
              },
            },
            {
              label: t("order.manager"),
              key: `manager`,
              sort: true,
              filter: {
                type: "select",
                axio: `/user/select`,
                axioAdapter: (data) => {
                  console.log("🚀 ~ Manager ~ data:", data);
                  return data.map(({ value, label }) => ({
                    value: value,
                    label: label,
                  }));
                },
              },
              render: ({ manager }) => {
                return <div>{objectPath.get(manager, "firstname")}</div>;
              },
            },
            {
              label: t("order.started"),
              key: `started`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ started }) => {
                return started
                  ? moment(started).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              },
            },

            {
              label: t("order.factory"),
              key: `factory`,
              sort: true,
              filter: {
                type: "select",
                axio: `/user/select`,
                axioAdapter: (data) => {
                  console.log("🚀 ~ Manager ~ data:", data);

                  return data.map(({ value, label }) => ({
                    value: value,
                    label: label,
                  }));
                },
              },
              render: ({ factory }) => {
                return <div>{objectPath.get(factory, "firstname")}</div>;
              },
            },
            {
              label: t("order.finished"),
              key: `finished`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ finished }) => {
                return finished
                  ? moment(finished).format("YYYY-MM-DD HH:mm:ss")
                  : "";
              },
            },
            {
              label: `${t("order.company")} / ${t("order.register")}`,
              key: `company`,
              sort: true,
              filter: {
                type: "text",
              },
              render: ({ company, companyno }) => {
                return (
                  <div class="text-primary">{`${company} / ${companyno}`}</div>
                );
              },
            },
            {
              label: t("order.user"),
              key: `name`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("order.phone"),
              key: `phone`,
              sort: true,
              filter: {
                type: "text",
              },
            },
            {
              label: t("order.email"),
              key: `email`,
              sort: true,
              filter: {
                type: "text",
              },
            },

            {
              label: t("order.grandtotal"),
              key: `grandTotal`,
              sort: true,
              filter: {
                type: "text",
              },
            },
          ]}
        />
      </div>
    </div>
  );
};

export default List;
